import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export function SlideOver({
  title,
  open,
  onClose,
  children,
  panelClassName = 'max-w-md',
}: {
  title: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** Tailwind max-width classes for the panel (default max-w-md). */
  panelClassName?: string;
}) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[60]">
      <button
        type="button"
        aria-label="Close panel"
        className="absolute inset-0 bg-slate-950/40"
        onClick={onClose}
      />
      <aside
        className={`absolute inset-y-0 right-0 flex w-full ${panelClassName} flex-col bg-white shadow-2xl`}
      >
        <header className="flex items-center justify-between border-b border-slate-200 px-5 py-4">
          <h2 className="text-lg font-semibold text-slate-950">{title}</h2>
          <button
            type="button"
            className="rounded-lg p-2 text-slate-500 hover:bg-slate-100"
            onClick={onClose}
          >
            <X className="h-5 w-5" />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
      </aside>
    </div>,
    document.body,
  );
}
